import { useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../App";
import ios from "../images/ios.svg";
import google from "../images/google.svg";
import CmsMenu from "./CmsMenu";
import Label from "./Label";
import { getCmsPagePath, getShopPath } from "./functions";
import FacebookIcon from "./icons/FacebookIcon";
import TwitterIcon from "./icons/TwitterIcon";
import InstagramIcon from "./icons/InstagramIcon";
import WhatsappIcon from "./icons/WhatsappIcon";
import FoursquareIcon from "./icons/FoursquareIcon";
import PinterestIcon from "./icons/PinterestIcon";


function Footer() {
	const {
		settings,
		brand,
		shops,
		pages,
		menus,
		setCookieSettingsPopupVisible,
		forceMainBrandNavigation,
		mainSettings,
		masterFooterMenus,
		masterFooterPages,
		masterFooterShops,
		masterFooterLoaded,
		navigateViaMaster,
	} = useContext(AppContext);
	const useMasterFooter = forceMainBrandNavigation && masterFooterLoaded;
	const footerSettings = forceMainBrandNavigation ? mainSettings || settings : settings;
	const footerMenus = useMasterFooter ? masterFooterMenus : menus;
	const footerPages = useMasterFooter ? masterFooterPages : pages;
	const footerShops = !forceMainBrandNavigation
		? shops
		: brand == "main"
			? shops
			: useMasterFooter
				? masterFooterShops
				: [];
	const handleInternalFooterNavigation = (target) => {
		if (forceMainBrandNavigation) navigateViaMaster(target);
	};

	return (
		<div id="footer">
			<div className="mainfooter">
				{footerSettings.website.logo_footer && (
					<div className="footer-logo">
						<img src={footerSettings.website.logo_footer} />
					</div>
				)}
				<div className="mainfooter-info">
					<div className="menu-footer menu-footer-1">
						{footerMenus.filter((m) => m.section == "footer1").length > 0 && (
							<>
								{footerMenus.map(
									(menu, i) =>
										menu.section == "footer1" && (
											<CmsMenu
												data={menu}
												key={i}
												type="bubble"
												className=""
												onInternalNavigate={handleInternalFooterNavigation}
											/>
										)
								)}
							</>
						)}
					</div>
					<div className="footer-shops">
						{footerShops.map((shop, i) => (
							<div key={i}>
								<Link
									key={i}
									className=""
									to={getShopPath(shop)}
									onClick={(e) => {
										if (!forceMainBrandNavigation) return;
										e.preventDefault();
										navigateViaMaster(getShopPath(shop));
									}}
								>
									<div className="title">{shop.city}</div>
									<div>
										<div>
											{shop.address}, {shop.number}
										</div>
										<div>{shop.phone && "Tel: " + shop.phone}</div>
										<div>{shop.email && "Email: " + shop.email}</div>
									</div>
								</Link>
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="prefooter">
				<div className="socials">
					{footerSettings.socials.facebook && (
						<a href={footerSettings.socials.facebook} target="_blank">
							<FacebookIcon></FacebookIcon>
						</a>
					)}
					{footerSettings.socials.twitter && (
						<a href={footerSettings.socials.twitter} target="_blank">
							<TwitterIcon></TwitterIcon>
						</a>
					)}
					{footerSettings.socials.instagram && (
						<a href={footerSettings.socials.instagram} target="_blank">
							<InstagramIcon></InstagramIcon>
						</a>
					)}
					{footerSettings.socials.foursquare && (
						<a href={footerSettings.socials.foursquare} target="_blank">
							<FoursquareIcon></FoursquareIcon>
						</a>
					)}
					{footerSettings.socials.pinterest && (
						<a href={footerSettings.socials.pinterest} target="_blank">
							<PinterestIcon></PinterestIcon>
						</a>
					)}
					{footerSettings.socials.whatsapp && (
						<a href={footerSettings.socials.whatsapp} target="_blank">
							<WhatsappIcon></WhatsappIcon>
						</a>
					)}
				</div>

				<div className="menu-prefooter menu-footer-2">
					{footerMenus.filter((m) => m.section == "footer2").length > 0 && (
						<>
							{footerMenus.map(
								(menu, i) =>
									menu.section == "footer2" && (
										<CmsMenu
											data={menu}
											key={i}
											type="bubble"
											className=""
											onInternalNavigate={handleInternalFooterNavigation}
										/>
									)
							)}
						</>
					)}
				</div>
			</div>
			<div className="subfooter">
				<div className="info">
					{footerSettings.global.company && (
						<div className="title">{footerSettings.global.company}</div>
					)}
					{footerSettings.global.vat && <div>P.Iva {footerSettings.global.vat}</div>}
					{footerSettings.global.taxcode && <div>C.F. {footerSettings.global.taxcode}</div>}
					{footerSettings.global.capital && (
						<div>Capitale Sociale: {footerSettings.global.capital}</div>
					)}
					{footerSettings.global.rea && <div>Numero REA: {footerSettings.global.rea}</div>}
					{footerPages.map(
						(page, i) =>
							page.menu_footer == 1 && (
								<div key={i}>
									<Link
										className=""
										to={getCmsPagePath(page)}
										onClick={(e) => {
											if (!forceMainBrandNavigation) return;
											e.preventDefault();
											navigateViaMaster(getCmsPagePath(page));
										}}
									>
										{page.title}
									</Link>
								</div>
							)
					)}
					{footerSettings && footerSettings.website.disable_cookies_banner != 1 && (
						<div>
							<Link className="" onClick={() => setCookieSettingsPopupVisible(true)}>
								<Label number={195} />
							</Link>
						</div>
					)}
					<div>
						<a href="https://www.yellgo.it" target="_blank">
							Powered by YellGO
						</a>
					</div>
				</div>
				{(footerSettings.website.ios_app_link || footerSettings.website.android_app_link) && (
					<div className="apps">
						{footerSettings.website.ios_app_link && (
							<div>
								<a href={footerSettings.website.ios_app_link} target="_blank">
									<img src={ios} />
								</a>
							</div>
						)}
						{footerSettings.website.android_app_link && (
							<div>
								<a href={footerSettings.website.android_app_link} target="_blank">
									<img src={google} />
								</a>
							</div>
						)}
					</div>
				)}
			</div>
		</div>
	);
}

export default Footer;
